export const micrositeVerifiedCategories = {
  COMPANY: "Company",
  GOVERNMENT: "Government",
  PUBLIC_FIGURE: "Public Figure",
  PUBLIC_SERVICE: "Public Services",
  ORGANIZATION: "Organization",
  INFLUENCER: "Influencer",
  CONTENT_CREATOR: "Content Creator",
  PARTY: "Party",
  COMMUNITY: "Community",
  TOURISM: "Tourism",
  TEACHER: "Teacher",
  UNIVERSITY: "University",
  SCHOOL: "School",
  JOURNALIST: "Journalist",
  SME: "SME (Small Medium Enterprise)",
};

export const micrositeVerifiedCategorieIcons = {
  COMPANY: "💼",
  GOVERNMENT: "🛡️",
  PUBLIC_FIGURE: "🙎",
  PUBLIC_SERVICE: "🧑‍🏭",
  ORGANIZATION: "🎗️",
  INFLUENCER: "👓",
  CONTENT_CREATOR: "⭐",
  PARTY: "👑",
  COMMUNITY: "👥",
  TOURISM: "🏖️",
  TEACHER: "📚",
  UNIVERSITY: "🎓",
  SCHOOL: "🏫",
  JOURNALIST: "🗞️",
  SME: "🏪",
};

const micrositeVerifiedCategoriesKeys = {
  COMPANY: "microsite_validation_type.company",
  GOVERNMENT: "microsite_validation_type.government",
  PUBLIC_FIGURE: "microsite_validation_type.public_figure",
  PUBLIC_SERVICE: "microsite_validation_type.public_service",
  ORGANIZATION: "microsite_validation_type.organization",
  INFLUENCER: "microsite_validation_type.influencer",
  CONTENT_CREATOR: "microsite_validation_type.content_creator",
  PARTY: "microsite_validation_type.party",
  COMMUNITY: "microsite_validation_type.community",
  TOURISM: "microsite_validation_type.tourism",
  TEACHER: "microsite_validation_type.teacher",
  UNIVERSITY: "microsite_validation_type.university",
  SCHOOL: "microsite_validation_type.school",
  JOURNALIST: "microsite_validation_type.journalist",
  SME: "microsite_validation_type.sme",
};

const micrositeVerifiedCategory = (t) => {
  if (typeof t !== "function") {
    let lists = [{ value: "", label: "- Select -" }];

    lists = [
      ...lists,
      ...Object.entries(micrositeVerifiedCategories).map(([value, label]) => {
        return { value, label };
      }),
    ];

    return lists;
  }

  let lists = [
    { value: "", label: t("microsite_validation_type.select_type") },
  ];

  lists = [
    ...lists,
    ...Object.entries(micrositeVerifiedCategoriesKeys).map(([value, label]) => {
      return { value, label: t(label) };
    }),
  ];

  return lists;
};

export const micrositeGetVerifiedCategoryName = (t, key) => {
  if (typeof t !== "function") {
    return micrositeVerifiedCategories[key] || "-";
  }

  return micrositeVerifiedCategoriesKeys[key]
    ? t(micrositeVerifiedCategoriesKeys[key])
    : "-";
};

export default micrositeVerifiedCategory;
